import { z } from "zod";
import { StructureType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/CreateStructure/createStructureType";

export interface ICreateStructure {
  name: string;
  type: string;
  avatarBase64: string | null;
}

export const createStructureScheme = z.object({
  name: z
    .string()
    .trim()
    .min(3, "Nazwa jest za krótka. Minimum 3 znaki")
    .max(128, "Nazwa jest za długa. Maksymalnie 128 znaków"),
  type: z.enum(StructureType),
  avatarBase64: z.string().nullable(),
});
